import React from 'react';
import './WebsiteSummaryCard.css';

const WebsiteSummaryCard = ({ site, scanData }) => {
  const data = scanData || {};
  const ip = data.ip || data.ip_address || '';
  const hosting = data.hosting || '';
  const runningOn = data.runningOn || '';
  const server = data.server || runningOn || '';
  const cms = (data.cms ? `${data.cms} ${data.cms_version || ''}` : '').trim();
  const poweredBy = data.powered_by || data.poweredBy || '';

  console.log('[WebsiteSummaryCard] rendering meta fields', { ip, hosting, runningOn, server, cms, poweredBy, raw: data });
  
  return (
    <div className="website-summary-card">
      <div className="summary-header">
        <h2>{site?.name || site?.url}</h2>
        <div className="summary-url">
          <span className="url-icon">📄</span>
          {site?.url || 'N/A'}
        </div>
      </div>
      
      <div className="summary-details">
        <div className="detail-row">
          <span className="detail-label">IP address:</span>
          <span className="detail-value">{ip}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Hosting:</span>
          <span className="detail-value">{hosting}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Running on:</span>
          <span className="detail-value">{server}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">CMS:</span>
          <span className="detail-value">{cms || 'Unknown'}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Powered by:</span>
          <span className="detail-value">{poweredBy || 'Unknown'}</span>
        </div>
        {data.more_details && (
          <div className="detail-row">
            <a href={data.more_details} className="more-details-link">More Details</a>
          </div>
        )}
      </div>
    </div>
  );
};

export default WebsiteSummaryCard;

